export const SpecialAttachment:{[id:string]: string}={ //Erweiterbar falls neue Anhänge auch besondere Rechte brauchen
    "job":"job"
}